import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { telegramClientApi } from '@/shared/api';
import { GetFantomRunResponseType } from '@/entities';

export interface FantomRunState extends GetFantomRunResponseType {
  loading: boolean;
  error: string | null;
}

const initialState: FantomRunState = {
  data: [],
  loading: false,
  error: null
};

export const fetchFantomRunPlays = createAsyncThunk<
  GetFantomRunResponseType,
  void,
  { rejectValue: string }
>('fantomRun/fetchFantomRunPlays', async (_, { rejectWithValue }) => {
  try {
    const res = await telegramClientApi.getFantomRunPlays();

    if (res.error === null && res.data) {
      return res.data;
    } else if (res.error !== null) {
      return rejectWithValue(res.error.message);
    }

    return rejectWithValue('Unknown error occurred');
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});

const fantomRunPlaysSlice = createSlice({
  name: 'fantomRun',
  initialState,
  reducers: {
    clearFantomRunData: (state) => {
      state.data = [];
      state.error = null;
    },
    resetFantomRunState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFantomRunPlays.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFantomRunPlays.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchFantomRunPlays.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch fantom run plays';
      });
  }
});

export const { clearFantomRunData, resetFantomRunState } = fantomRunPlaysSlice.actions;

export default fantomRunPlaysSlice.reducer;
